import {
  EntityProfileSummaryBlock as SummaryBlock,
  EntityProfileSummaryRow as SummaryRow,
} from "../../../../../entityProfileModal/components/EntityProfileSummary";
import { PatientProfilePatient } from "../../../../patientProfileModal.types";

export type PatientProfileSummaryStatusProps = {
  isEditing: boolean;
  patient: PatientProfilePatient;
  onChangeStatus: () => void;
};

export function PatientProfileSummaryStatus(props: PatientProfileSummaryStatusProps) {
  return (
    <SummaryBlock title="Status">
      <SummaryRow
        isClickable={props.isEditing}
        label="Status"
        value={props.patient.status}
        onClick={props.isEditing ? props.onChangeStatus : undefined}
      />
    </SummaryBlock>
  );
}
